import { render, staticRenderFns } from "./UsersWidget.vue?vue&type=template&id=0c6b3ae1&"
import script from "./UsersWidget.vue?vue&type=script&lang=js&"
export * from "./UsersWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports